
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.footer{
  background-color:var(--brand-primary-1);
  padding:3rem 1.5rem;
}

.footer-main-content{
  display:flex;
  flex-direction:column;
  color:var(--gray-100);
  padding-bottom:1.5rem;
}

@media (min-width: 1024px){

.footer-main-content{
    flex-direction:row;
    gap:1.5rem
}
  }

nav{
  display:flex;
  width:100%;
}

nav > ul{
    padding:1rem 0;
    list-style:none;
    margin:0px;
    display:flex;
    flex-wrap:wrap;
    width:100%;
    gap:3rem;
  }

@media (min-width: 1024px){

nav > ul{
      gap:1.5rem;
      padding:0px;
      flex-wrap:nowrap;
      justify-content:center
  }
    }

nav > ul ul{
    list-style:none;
    font-family:var(--ff-dmsans);
    padding:0 0 1.25rem 0;
    flex-direction:column;
  }

nav h2{
    font-size:var(--fs-sm) !important;
    letter-spacing:1px !important;
    font-weight:100 !important;
    font-family:var(--ff-dmsans);
    margin-bottom:1rem;
    margin-top:0;
  }

nav li{
    color:var(--brand-neutral-white);
    margin:0;
    padding-bottom:0.25rem;
  }

nav a{
    color:var(--brand-neutral-white);
    text-decoration:none;
  }

nav a:hover{
      text-decoration:underline;
    }

.footer-social{
  width:100%;
  max-width:270px;
}

@media (max-width: 767px){

.footer-social{
    max-width:210px
}
  }

.footer-social h2{
    margin:0;
  }

.footer-social--list{
  margin:0;
  padding:1rem 0px;
  display:flex;
  color:var(--brand-neutral-white);
  width:100%;
  justify-content:space-between;
}

.footer-legal{
  font-size:var(--fs-sm);
  font-family:var(--ff-dmsans);
  line-height:var(--lh-base);
  color:var(--gray-100);
  max-width:900px;
  margin:0;
}

.footer-logo{
  display:flex;
  max-width:140px;
  height:-moz-fit-content;
  height:fit-content;
  padding-bottom:2rem;
  width:100%;
}

@media (max-width: 767px){

.footer-logo{
    max-width:100px
}
  }
`;